import styles from "./styles.module.css"
import logoText from "./logotext.svg"
import GSLogo from "./gslogo.svg"

export default function Footer() {
  return (
    <div className={`flex align-items-center px-2 ${styles.footer}`}>
      <img src={logoText} alt={"Logo"} height={20}/>
      <img src={GSLogo} alt={"GoodSailors logo"} height={20} className={"ml-auto"}/>
    </div>
  )
}
